/* Import Leverege Modules */
import Unit from '@leverege/unit';
import { Plugins } from '@leverege/plugin';

/* Import Local Modules */
import Util from './Util.js';
import AttributeDetailRenderer from "./AttributeDetailRenderer.js";
import AttributeDetailModel from './AttributeDetailModel.js';
import AttributeDetailEditor from "./AttributeDetailEditor.js";
import UnitAttributeDetailModel from './UnitAttributeDetailModel.js';
import UnitAttributeDetailEditor from "./UnitAttributeDetailEditor.js";
import UnitAttributeDetailRenderer from "./UnitAttributeDetailRenderer.js";
import GeoPointAttributeDetailModel from './GeoPointAttributeDetailModel.js';
import GeoPointAttributeDetailRenderer from "./GeoPointAttributeDetailRenderer.js";
import ImageDetailModel from './ImageDetailModel.js';
import ImageDetailRenderer from "./ImageDetailRenderer.js";
import BooleanAttributeDetailModel from './BooleanAttributeDetailModel.js';
import BooleanAttributeDetailRenderer from "./BooleanAttributeDetailRenderer.js";
import ArrayPrimitiveAttributeDetailModel from './ArrayPrimitiveAttributeDetailModel.js';
import ArrayPrimitiveAttributeDetailRenderer from "./ArrayPrimitiveAttributeDetailRenderer.js";
import ArrayPrimitiveAttributeDetailEditor from "./ArrayPrimitiveAttributeDetailEditor.js"; // Set up Unit specific Details models, editors and renderers
function createUnitSpecificObjects() {
  const types = Unit.getUnitTypes();
  types.forEach(type => {
    // const key = `${type[0].toUpperCase()}${type.substring( 1 )}`
    const detailType = Util.getDetailTypeForType(type);
    const model = UnitAttributeDetailModel.createFor(type);
    const editor = UnitAttributeDetailEditor;
    const renderer = UnitAttributeDetailRenderer;

    // exports[`${key}AttributeDetailModel`] = model
    // exports[`${key}AttributeDetailRenderer`] = UnitAttributeDetailRenderer

    // Not super happy with plugin registration here, but it can 
    // be overwritten if necessary
    Plugins.add('Model', {
      type: detailType,
      model
    });
    Plugins.add('ModelEditor', {
      type: detailType,
      editor
    });
    Plugins.add('DetailRenderer', {
      type: detailType,
      renderer
    });
  });
}

/* Export Modules */
export default {
  install: opts => {
    // Add unit plugins
    createUnitSpecificObjects();

    // Add base plugin
    Plugins.add('Model', {
      type: AttributeDetailModel.TYPE,
      model: AttributeDetailModel
    });
    Plugins.add('ModelEditor', {
      type: AttributeDetailModel.TYPE,
      editor: AttributeDetailEditor
    });
    Plugins.add('DetailRenderer', {
      type: AttributeDetailModel.TYPE,
      renderer: AttributeDetailRenderer
    });

    // Add string plugin, Note: the string attribute is pretty much the default/generic attribute detail model
    const strType = Util.getDetailTypeForType('string');
    Plugins.add('Model', {
      type: strType,
      model: AttributeDetailModel.createFor(strType)
    });
    Plugins.add('ModelEditor', {
      type: strType,
      editor: AttributeDetailEditor
    });
    Plugins.add('DetailRenderer', {
      type: strType,
      renderer: AttributeDetailRenderer
    });

    // Add base plugin
    Plugins.add('Model', {
      type: ArrayPrimitiveAttributeDetailModel.TYPE,
      model: ArrayPrimitiveAttributeDetailModel
    });
    Plugins.add('ModelEditor', {
      type: ArrayPrimitiveAttributeDetailModel.TYPE,
      editor: ArrayPrimitiveAttributeDetailEditor
    });
    Plugins.add('DetailRenderer', {
      type: ArrayPrimitiveAttributeDetailModel.TYPE,
      renderer: ArrayPrimitiveAttributeDetailRenderer
    });

    // Add string plugin, Note: the string attribute is pretty much the default/generic attribute detail model
    const strArrType = Util.getDetailTypeForType('string*');
    Plugins.add('Model', {
      type: strArrType,
      model: ArrayPrimitiveAttributeDetailModel.createFor(strArrType)
    });
    Plugins.add('ModelEditor', {
      type: strArrType,
      editor: ArrayPrimitiveAttributeDetailEditor
    });
    Plugins.add('DetailRenderer', {
      type: strArrType,
      renderer: ArrayPrimitiveAttributeDetailRenderer
    });

    // Add geopoint plugin
    Plugins.add('Model', {
      type: GeoPointAttributeDetailModel.TYPE,
      model: GeoPointAttributeDetailModel
    });
    Plugins.add('ModelEditor', {
      type: GeoPointAttributeDetailModel.TYPE,
      editor: AttributeDetailEditor
    });
    Plugins.add('DetailRenderer', {
      type: GeoPointAttributeDetailModel.TYPE,
      renderer: GeoPointAttributeDetailRenderer
    }); // eslint-disable-line

    // Add image plugin
    Plugins.add('Model', {
      type: ImageDetailModel.TYPE,
      model: ImageDetailModel
    });
    Plugins.add('ModelEditor', {
      type: ImageDetailModel.TYPE,
      editor: AttributeDetailEditor
    });
    Plugins.add('DetailRenderer', {
      type: ImageDetailModel.TYPE,
      renderer: ImageDetailRenderer
    });

    // Add boolean plugin
    Plugins.add('Model', {
      type: BooleanAttributeDetailModel.TYPE,
      model: BooleanAttributeDetailModel
    });
    Plugins.add('ModelEditor', {
      type: BooleanAttributeDetailModel.TYPE,
      editor: AttributeDetailEditor
    });
    Plugins.add('DetailRenderer', {
      type: BooleanAttributeDetailModel.TYPE,
      renderer: BooleanAttributeDetailRenderer
    });
  }
};